import React, { useState, useEffect } from 'react';
import API from '../utils/api';

export default function GallerySection({ waNumber = '917904082095' }) {
  const [collage, setCollage]   = useState([]);
  const [extra, setExtra]       = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    Promise.all([
      API.get('/gallery?collage=true'),
      API.get('/gallery?collage=false'),
    ]).then(([c, e]) => {
      if (c.data.success) setCollage(c.data.data);
      if (e.data.success) setExtra(e.data.data);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const FALLBACK_TILES = [
    { id:'f1', cat:'Bridal',  emoji:'🌸', grad:'linear-gradient(145deg,#E0B0CC,#C890A8,#A8688A)' },
    { id:'f2', cat:'Makeup',  emoji:'💄', grad:'linear-gradient(135deg,#ECC0D8,#D8A4C0,#C088A8)' },
    { id:'f3', cat:'Facial',  emoji:'✨', grad:'linear-gradient(225deg,#D4A4BC,#C28CA8,#A87090)' },
    { id:'f4', cat:'Hair',    emoji:'💇', grad:'linear-gradient(160deg,#EED4E4,#DDB8CE,#CC9CB8)' },
    { id:'f5', cat:'Nails',   emoji:'💅', grad:'linear-gradient(145deg,#D8ACC4,#C494B0,#AA789C)' },
    { id:'f6', cat:'Skin',    emoji:'🌿', grad:'linear-gradient(135deg,#E8C0D4,#D4A4BE,#BC88A8)' },
    { id:'f7', cat:'Spa',     emoji:'💆', grad:'linear-gradient(180deg,#DDBACE,#C9A0B8,#B184A0)' },
    { id:'f8', cat:'Bridal',  emoji:'👰', grad:'linear-gradient(160deg,#CCA0B8,#BF8EA8,#AD7898)' },
  ];

  const collageItems = collage.length ? collage : FALLBACK_TILES;

  const waMsg = encodeURIComponent(
    "Hello ANN'S Beauty Parlour! I saw your gallery and I'd like to know more about your services and book an appointment. 🌸"
  );
  const waLink = `https://wa.me/${waNumber}?text=${waMsg}`;

  return (
    <section id="gallery" className="gallery-section">
      <div className="container">
        <div className="sec-hd">
          <span className="sec-chip">✦ Our Work</span>
          <h2 className="sec-title">A glimpse of our <em>artistry</em></h2>
          <div className="sec-rule" />
        </div>

        {/* Preserved collage grid layout */}
        <div className="gallery-grid">
          {collageItems.slice(0, 8).map((item, i) => (
            <div
              key={item._id || item.id}
              className={`gi gi-${i + 1}`}
              style={item.imageUrl ? {} : { background: item.grad }}
            >
              {item.imageUrl
                ? <img src={item.imageUrl} alt={item.caption || `Gallery ${i+1}`} className="gi__img" />
                : <div className="gi__fill"><span>{item.emoji}</span></div>
              }
              
              <div className="gi__ovl"><span>{item.caption || item.cat}</span></div>
            </div>
          ))}
        </div>

        {/* WhatsApp CTA */}
        <div className="gallery-wa-row">
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="gallery-wa-btn"
            aria-label="Chat on WhatsApp"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
              <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.116 1.527 5.845L0 24l6.337-1.503A11.943 11.943 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.854 0-3.6-.493-5.113-1.354l-.363-.215-3.762.892.947-3.655-.237-.379A9.953 9.953 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
            </svg>
            Chat with Us on WhatsApp
          </a>
        </div>

        {/* See More */}
        {extra.length > 0 && (
          <div className="gallery-more">
            {!showMore ? (
              <button className="btn-clay-outline" onClick={() => setShowMore(true)}>
                See More Work ↓
              </button>
            ) : (
              <>
                <div className="gallery-extra-grid">
                  {extra.map(item => (
                    <div key={item._id} className="gallery-extra-item">
                      <img src={item.imageUrl} alt={item.caption} />
                      {item.caption && <span className="gallery-extra-caption">{item.caption}</span>}
                    </div>
                  ))}
                </div>
                <button className="btn-clay-outline" onClick={() => setShowMore(false)}>
                  Show Less ↑
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
